import React from "react";
import { useDarkMode } from "@hooks/index";

/**
 * Theme toggle button component
 * Allows users to switch between light, dark, and system themes
 * Note: memo is not used here because the component takes no props —
 * re-renders are driven by internal hook state which bypasses memo.
 */
function ThemeToggle(): React.ReactElement {
    const { theme, isDark, toggleTheme } = useDarkMode();

    const getIcon = (): string => {
        if (theme === 'system') return '💻';
        return isDark ? '🌙' : '☀️';
    };

    const getLabel = (): string => {
        if (theme === 'system') return 'System theme';
        return isDark ? 'Dark mode' : 'Light mode';
    };

    return (
        <button
            onClick={toggleTheme}
            className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 dark:focus:ring-offset-gray-900"
            aria-label={`Current theme: ${getLabel()}. Click to toggle.`}
            title={getLabel()}
        >
            <span className="text-lg" role="img" aria-hidden="true">
                {getIcon()}
            </span>
        </button>
    );
}

export default ThemeToggle;
